/**
 * Quando true: exige e envia CPF e Celular na validação do vale gás (/valegas/validar).
 * Quando false: os campos não aparecem e não são enviados na API.
 *
 * Altere para true ou false conforme precisar.
 */
export const requireCpfPhoneValegas = false;
